import { Button } from 'antd';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { notificationsActions } from '@sonar-software/sonar-notifications';
import { useAction } from '../../hooks';
import React, { useCallback } from 'react';
export const ClearAllNotifications = ({ id }) => {
    const clear = useAction(notificationsActions.requestDeleteNotifications);
    const handleClick = useCallback(() => {
        clear();
    }, [clear]);
    return (React.createElement(Button, { id: id, onClick: handleClick }, COPY_SPECIFIC.CLEAR_ALL));
};
